import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ItemsListRowItemBase } from '../list-row-item-base';
import { ItemsListRowItemDisplayValueComponent } from '@fi-app/components/items-list/list-row/list-row-item/display-value/display-value.component';

@Component({
    selector: 'fi-items-list-row-item-span-plain',
    template: `
        <span
            class="CcmListItemTextOverflow CcmListItemName"
            [ngClass]="getMainValueClass()"
            (click)="onClick($event)"
            [attr.title]="getDisplayValue()"
        >
            {{ getDisplayValue() }}
        </span>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-items-list-row-item-span-plain' },
    standalone: false,
})
export class ItemsListRowItemSpanPlainComponent extends ItemsListRowItemBase {
    getDisplayValue() {
        return ItemsListRowItemDisplayValueComponent.GetDisplayValue(this.data, this.head, this.parentData);
    }

    getMainValueClass() {
        return this.head.Properties.ExtraProperties && this.head.Properties.ExtraProperties.getMainValueClass
            ? this.head.Properties.ExtraProperties.getMainValueClass(this.data)
            : '';
    }

    onClick($event: MouseEvent) {
        if (this.head.Properties.ExtraProperties && this.head.Properties.ExtraProperties.onClick) {
            this.head.Properties.ExtraProperties.onClick($event, this.data, this.parentData);
        }
    }
}
